import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '@appbase/store/types';
// components
import { ToolbarButton } from '@appbase/components/atom';
import { PopupModal } from '@appbase/components/molecule';
import GraphList from '../GraphList.vue';
import ProgressRing from '../../atom/ProgressRing.vue';

@Component({
    components: { PopupModal, ToolbarButton, GraphList, ProgressRing },

    computed: {
        ...mapGetters({
        }),
    },

    methods: {
        ...mapActions({
            changeModal: types.MODAL_CHANGE,
        }),
        ...mapMutations({
            selectedAttachment: types.SELECT_ATTACHMENT
        })
    },
})
export default class EmailAttachmentModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean }) show!: boolean;
    @Prop({ type: String }) items!: string;
    // @Prop({ type: Boolean }) _isloading!: boolean;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    user!: User;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    changeModal!: (option: basemail.ModalOption | null) => void;

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    selectedAttachment!: (item:any) => void;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    selectedFolder: basemail.MailboxFolder | null = null;
    //loading: boolean = false;
    selectedId: string = '';
    selectItem: any = {};
    highlightId: any = [];
    loading: boolean = false
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    // get isDeletedFolder() {
    //     return this.node?.wellKnownFolderName === 'deleteditems';
    // }

    // get targetEmails() {
    //     // 컨텍스트 데이터가 없을 경우 선택된 아이템을 대상으로
    //     return this.items || this.selections;
    // }

    // get _isloading() {
    //     return this.loading
    // }

    // set _isloading(value: boolean) {
    //     console.log("valuevaluevalue", value);
    //     this.loading = value
    // }

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    item: basemail.graphOption = {
        o365GuId: '',
        teamsId: '',
        channelId: '',
        driveId:'',
        itemId: '',
        groupId: ''
    }

    selectedItem: any = [];
    oneDriveList:any = [];
    teamsList:any = [];
    // navigationList: any = [{
    //     id:'default',
    //     name:'OneDrive'
    // }];
    navigationList: any = [];
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

 
    created() {
        this._isloading(true)
        //this.loading = true
        // this.item.o365GuId = this.user.o365Guid;
        this.navigation({id:'', name:this.items})
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    naviationClick(item:any, idx:number){
        this._isloading(true)
        this.selectedItem = []
        this.highlightId = []
        //this.selectedId = item.id
        this.navigationList.forEach((i:any, index: number) =>{
            if(index > idx){
                this.navigationList.splice(index)
            }
        })
        if(this.items == 'Teams'){
            item.order = idx + 1
        }
        this.selectItem = item; 
    }

    navigation(item:any){
        this._isloading(true)
        this.selectedItem = []
        this.highlightId = []
        this.navigationList.push(item)
        //this.selectedItem = item;
        //this.selectedItem.push(item)
        //this.selectedId = item.id
    }

    select(item:any){
        //this._isloading(true)
        //최초 Teams 불러온경우 Teams Channel 가져오기
        // if(this.items == 'Teams' && this.selectedId == ''){
        //     this.navigation({id:item.id, name:item.name})
        //     this.item.teamsId = item.id;
        //     this.item.itemId = item.id;
        // }
        var selectedItemYn = true
        if(this.items == 'Teams'){
            if(item.order == 1 || item.order == 2){
                this.$set(item, 'teamsId', this.navigationList[parseInt(item.order) - 1].id)
                this.navigation(item)
                selectedItemYn = false;
                this.selectItem = item; 
                //console.log("this.selectItemthis.selectItem", this.selectItem);
            }
            else{
                if(item.folder){
                    this.navigation(item)
                    selectedItemYn = false;
                    this.selectItem = item; 
                }
            }
            item.order = parseInt(item.order) + 1
        }
        else{
            if(item.folder){
                this.navigation(item)
                //this.item.driveId = item.id;
                //this.item.itemId = item.id;
                selectedItemYn = false;
                this.selectItem = item; 
            }
        }

        if(selectedItemYn){
            let idx = this.highlightId.indexOf(item.id)

            if (idx !== -1) {
                this.highlightId.splice(idx, 1)
                this.selectedItem.splice(idx, 1)
            } else {
                this.highlightId.push(item.id)
                this.selectedItem.push(item)
            }
        }
        //this._isloading = false;
    }
    

    ok() {
        // for(var i=0; i< this.selectedItem.length; i++) {
        //     var item = this.selectedItem[i];
        //     if(!this.getDocumentIcon(item.name))
        //     {
        //         await(window as any).alertAsync(this.$t('MS_OFFICE_통합문서파일_PPTX_DOCX_XLSX_로_변환_후_신청_부탁_드립니다').toString());
        //         return false
        //     }
        // }

        this.selectedItem.forEach((i:any) =>{
            var blobt: any = null;
            fetch(i["@microsoft.graph.downloadUrl"])
            .then(res => res.blob()) 
            .then(blob => {
                const itemFile = new File([blob], i.name, {
                    type: blob.type,
                });
                this.selectedAttachment(itemFile);
            });
        })

        this.close();
    }

    cancel() {
        this.close();
    }

    close() {
        this.changeModal(null);
    }

    getDocumentIcon(filename: string) {
        var extension = filename.split('.').pop()?.toLowerCase();
        var value = false;
        if (extension == "docx" || extension == "pptx" || extension == "xlsx"){
            value = true;
        }
        return value;
    }

    _isloading(value: boolean) {
        this.loading = value;
    }
}
